export default "__VITE_ASSET__CIMUFPBc__"